(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["video-carousel-slider"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('fbs-video-carousel')) return;
  let libraryPromise;
  function loadFlickity() {
    if (window.Flickity) return Promise.resolve(window.Flickity);
    if (!libraryPromise) {
      libraryPromise = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://cdn.shopify.com/s/files/1/0877/3884/3451/files/flickity-2.3.0.pkgd.min.js?v=1735273781';
        script.async = true;
        const timer = setTimeout(() => finish(new Error('Flickity timed out')), 20000);
        function finish(error) {
          clearTimeout(timer);
          script.onload = script.onerror = null;
          if (error) { script.remove(); reject(error); }
          else resolve(window.Flickity);
        }
        script.onload = () => finish(window.Flickity ? null : new Error('Flickity unavailable'));
        script.onerror = () => finish(new Error('Flickity could not load'));
        document.head.appendChild(script);
      }).catch(error => { libraryPromise = null; throw error; });
    }
    return libraryPromise;
  }
  class VideoCarousel extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.slider = this.querySelector('.fbs-pck__video-slider');
      this.videos = Array.from(this.querySelectorAll('video'));
      this.cells = Array.from(this.querySelectorAll('[data-block-id]'));
      this.visible = false;
      this.sound = false;
      this.editorSelected = false;
      this.pendingIndex = 0;
      if (!this.slider || !this.cells.length) return;
      this.cells[0].classList.add('is-selected');
      this.addEventListener('click', event => this.click(event), { signal });
      this.addEventListener('keydown', event => {
        if ((event.key === 'Enter' || event.key === ' ') && event.target.matches('.fbs-pck__nav-button')) {
          event.preventDefault(); event.target.click();
        }
      }, { signal });
      document.addEventListener('visibilitychange', () => this.sync(), { signal });
      this.addEventListener('shopify:block:select', event => {
        this.editorSelected = true;
        const index = this.cells.findIndex(cell => cell.dataset.blockId === event.detail.blockId);
        this.pendingIndex = Math.max(0, index);
        this.start().then(() => {
          if (!this.flkty) return;
          this.flkty.stopPlayer();
          this.flkty.selectCell(this.pendingIndex, false, true);
          this.sync();
        });
      }, { signal });
      this.addEventListener('shopify:block:deselect', () => {
        this.editorSelected = false;
        this.sync();
      }, { signal });
      const beginObserving = () => {
        if (signal.aborted) return;
        if ('IntersectionObserver' in window) {
          this.nearObserver = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) {
              this.nearObserver.disconnect();
              this.posters();
              this.start();
            }
          }, { rootMargin: '300px 0px' });
          this.nearObserver.observe(this);
          this.viewObserver = new IntersectionObserver(entries => {
            this.visible = entries[0].isIntersecting;
            this.sync();
          });
          this.viewObserver.observe(this);
        } else {
          this.posters();
          this.visible = this.getBoundingClientRect().bottom > 0 && this.getBoundingClientRect().top < innerHeight;
          this.start();
          window.addEventListener('scroll', () => {
            const rect = this.getBoundingClientRect();
            this.visible = rect.bottom > 0 && rect.top < innerHeight;
            this.sync();
          }, { signal, passive: true });
        }
      };
      // Do not compete with the initial page's images and other critical resources.
      if (document.readyState === 'complete') beginObserving();
      else window.addEventListener('load', beginObserving, { once: true, signal });
    }
    posters() {
      this.videos.forEach(video => {
        if (video.dataset.poster) {
          video.poster = video.dataset.poster;
          delete video.dataset.poster;
        }
      });
    }
    start() {
      if (this.flkty) return Promise.resolve();
      if (this.starting) return this.starting;
      const signal = this.controller.signal;
      this.posters();
      this.starting = loadFlickity().then(Flickity => {
        if (signal.aborted || !this.isConnected) return;
        const style = getComputedStyle(this);
        const read = (name, fallback) => {
          try { return JSON.parse(style.getPropertyValue(name)); } catch (_) { return fallback; }
        };
        this.cells.forEach(cell => cell.classList.remove('is-selected'));
        this.flkty = new Flickity(this.slider, {
          cellSelector: '.fbs-pck__item',
          cellAlign: read('--cell-align', 'center'),
          autoPlay: false,
          draggable: read('--draggable', '>1'),
          contain: true,
          wrapAround: read('--wrap-around', false),
          adaptiveHeight: false,
          watchCSS: false,
          prevNextButtons: false,
          pageDots: false,
          initialIndex: this.pendingIndex
        });
        // Set the interval without starting the player while the section is offscreen.
        this.flkty.options.autoPlay = Number(this.dataset.autoplay) || false;
        this.slider.classList.add('fbs-pck__stretch-height');
        this.flkty.on('change', () => this.sync());
        this.flkty.on('staticClick', (event, pointer, cell, index) => {
          if (event.target.closest('button, a, .fbs-pck__nav-button')) return;
          if (typeof index === 'number') {
            this.flkty.selectCell(index);
            this.sync();
          }
        });
        this.sync();
      }).catch(error => {
        if (!signal.aborted) console.warn('Video carousel:', error.message);
      }).finally(() => { if (!signal.aborted) this.starting = null; });
      return this.starting;
    }
    sync() {
      const active = this.flkty && this.visible && !document.hidden;
      const selected = this.flkty ? this.flkty.selectedIndex : -1;
      this.videos.forEach((video, index) => {
        if (active && index === selected) {
          if (!video.dataset.loaded) {
            video.querySelectorAll('source[data-src]').forEach(source => {
              source.src = source.dataset.src;
            });
            video.dataset.loaded = 'true';
            video.load();
          }
          video.muted = !this.sound;
          if (video.paused) {
            const promise = video.play();
            if (promise) promise.catch(() => {});
          }
        } else video.pause();
      });
      if (!this.flkty) return;
      if (!active || this.editorSelected) this.flkty.pausePlayer();
      else this.flkty.unpausePlayer();
      // Flickity's player starts stopped because autoPlay is initially disabled.
      if (active && !this.editorSelected && !this.playerStarted && this.flkty.options.autoPlay) {
        this.flkty.playPlayer();
        this.playerStarted = true;
      }
    }
    click(event) {
      const sound = event.target.closest('.fbs-pck__sound-button');
      const previous = event.target.closest('.fbs-pck__nav-button--prev');
      const next = event.target.closest('.fbs-pck__nav-button--next');
      if (!sound && !previous && !next) return;
      event.preventDefault();
      if (!this.flkty) {
        this.start().then(() => { if (this.flkty) this.perform(sound, previous, next); });
      } else this.perform(sound, previous, next);
    }
    perform(sound, previous, next) {
      if (sound) {
        const cell = sound.closest('[data-block-id]');
        this.flkty.selectCell(this.cells.indexOf(cell));
        this.sound = !this.sound;
        this.querySelectorAll('.fbs-pck__sound-button').forEach(button => {
          button.classList.toggle('fbs-pck__sound-button--on', this.sound);
          button.setAttribute('aria-pressed', String(this.sound));
          button.setAttribute('aria-label', this.sound ? 'Mute video' : 'Unmute video');
        });
        this.sync();
      } else if (previous) this.flkty.previous();
      else if (next) this.flkty.next();
    }
    disconnectedCallback() {
      if (!this.controller) return;
      this.controller.abort();
      this.nearObserver?.disconnect();
      this.viewObserver?.disconnect();
      this.videos?.forEach(video => {
        video.pause();
        video.querySelectorAll('source').forEach(source => source.removeAttribute('src'));
        delete video.dataset.loaded;
        video.load();
      });
      this.flkty?.destroy();
      this.slider?.classList.remove('fbs-pck__stretch-height');
      this.flkty = this.starting = this.controller = null;
      this.playerStarted = false;
    }
  }
  customElements.define('fbs-video-carousel', VideoCarousel);
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('fbs-video-carousel').forEach(section => section.disconnectedCallback());
  });
})();


  } catch(e) { console.error(e); }
})();
})();
